import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import ConfigurationDomainsAddDomainView from './configuration-domains-add.view';

const ConfigurationDomainsConfigurationView = (props) =>{
    const { t } = useTranslation();

    let {
      token,
      setStateNameComponentUser,
      stateNameComponentUser,
      nameComponentUser,
      hideShowDetails,
      setHeaderTitleinDetail,
      showCompletedRequest,        
    } = props

    const [showDetailComponent, setShowComponentDetail] = useState(false);


    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    
    
      useEffect(() => {
        setStateNameComponentUser(nameComponentUser);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [nameComponentUser]);
    
      useEffect(() => {
        renderComponentQuestionnaire();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [stateNameComponentUser]);
    
      const renderComponentQuestionnaire = useCallback(() => {
        switch (stateNameComponentUser) {    
          case t("configurationDomainView.newDomain"):
            return (
              <ConfigurationDomainsAddDomainView 
                {...props}
              /> 
            )
            case t("configurationPanelView.detail.domain.btn"):
              return (
                <ConfigurationDomainsAddDomainView 
                  {...props}
                /> 
              );          
            default:
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [
        stateNameComponentUser,
        hideShowDetails,
        setHeaderTitleinDetail,
        token,
        showDetailComponent,
        showCompletedRequest,
      ]);
    
      return <>{renderComponentQuestionnaire()}</>;
    };
        
export default ConfigurationDomainsConfigurationView